'use client'

import { useEffect, useRef, useState } from 'react'

const LG_MEDIA = '(min-width: 1024px)'

/**
 * On viewports below `lg`, tracks whether the inline submit block is in view.
 * When it is not, a duplicate fixed submit (same `form` id) can be shown.
 */
export function useMobileSubmitDock() {
	const submitAnchorRef = useRef<HTMLDivElement>(null)
	const [isLg, setIsLg] = useState(true)
	const [inlineSubmitVisible, setInlineSubmitVisible] = useState(true)

	useEffect(() => {
		const mq = window.matchMedia(LG_MEDIA)
		const sync = () => setIsLg(mq.matches)
		sync()
		mq.addEventListener('change', sync)
		return () => mq.removeEventListener('change', sync)
	}, [])

	useEffect(() => {
		if (isLg) {
			setInlineSubmitVisible(true)
			return
		}

		const el = submitAnchorRef.current
		if (!el) return

		const observer = new IntersectionObserver(
			([entry]) => {
				setInlineSubmitVisible(entry.isIntersecting)
			},
			{ threshold: 0.12, rootMargin: '0px 0px 72px 0px' }
		)
		observer.observe(el)
		return () => observer.disconnect()
	}, [isLg])

	const showFloatingSubmit = !isLg && !inlineSubmitVisible

	return { submitAnchorRef, showFloatingSubmit, isLg }
}
